module.exports = __webpack_public_path__ + "img/img_redirect@2x.f3c8068e.png";